import { useRef, useState, useEffect } from "react";
import styles from "../AddContacts/AddContacts.module.css";
import { emailValidate } from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";
import {
  contactResources,
  fetchConstants,
  fetchpropertySubType,
} from "../../Services/contacts";
import Loading from "../../Components/Loading/Loading";
import { showSnackbarAction } from "../../Redux/actions";
import { country_code, url, admin_mail } from "../../Values/constants";
import { useLocation } from "react-router";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import "../../theme-vars.css";
import { Circles } from 'react-loader-spinner';
import { useTheme, useMediaQuery, Box } from "@mui/material";
import { Button } from "@mui/material";
import { Grid } from "@material-ui/core";
import TextInput from '../../Components/TextInput/InputText';
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import DropDownText from "../../Components/DropDownText/DropDownText";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";


const primaryColor = "#292744";
// 🔹 Custom styled TextField
const CustomTextArea = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
    "&.Mui-focused fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: 16,
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: 15,
    color: primaryColor,
  },
});

const HelpAndSupport = ({
  history,
  user,
  organizationUsers,
  role,
  theme,
  conatctHeader,
  authToken,
  organizationData,
}: {
  history: any;
  user: any;
  organizationUsers: any;
  role: string;
  theme: any;
  conatctHeader: any;
  authToken: any;
  organizationData: any;
}) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const dispatcher = useDispatch();
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const emaileRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState<string[]>([]);
  const [countryCode, setCountryCode] = useState<string>("");
  const [note, setNote] = useState("");
  const noteRef: any = useRef();
  const [projectSelected, setProjectSelected] = useState<any>({ label: "Select", value: "Select" });
  const [locationSelected, setlocationSelected] = useState<any>({ label: "Select", value: "Select" });
  const [queryTypeSelected, setQueryTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [budgetSelected, setBudgetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadTypeSelected, setLeadTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({ label: "Select", value: "Select" });
  const [nextFollowSelected, setNextFollowSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadSourceSelected, setLeadSourceSelected] = useState<any>({ label: "Select", value: "Select" });
  const [addSetSelected, setAddSetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [campaignSetSelected, setCampaignSelected] = useState<any>({ label: "Select", value: "Select" });
  const [ownerSelected, setOwnerSelected] = useState<any>({ label: "Select", value: "Select" });
  const [usersList, setUsersList] = useState([]);
  const [projectsList, setProjectsList] = useState<any[]>([]);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [queryType, setQueryType] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<any[]>([]);
  const [propertyStageList, setPropertyStageList] = useState<any[]>([]);
  const [leadTypeList, setleadTypeList] = useState<any[]>([]);
  const [nextFollowUpList, setnextFollowUpList] = useState<any[]>([]);
  const [notIntReasonList, setNotIntReasonList] = useState<any[]>([]);
  const [lostReasonList, setLostReasonList] = useState<any[]>([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [uidList, setUidList] = useState<any>();
  const [addSet, setAddSet] = useState<any[]>([]);
  const [leadSource, setLeadSource] = useState<any[]>([]);
  const [campaign, setCampaign] = useState<any[]>([]);
  const [phoneCountryCode, setPhoneCountryCode] = useState('in');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [finalPhoneNumber, setFinalPhoneNumber] = useState('');
  const [alternatePhoneCountryCode, setAlternatePhoneCountryCode] = useState('in');
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState('');
  const [finalAlternatePhoneNumber, setFinalAlternatePhoneNumber] = useState('');

  const handlePhoneChange = (value: string, country: CountryData) => {
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
    setPhoneNumber(value)
  };

  const handleAlternatePhoneChange = (value: string, country: CountryData) => {
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalAlternatePhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalAlternatePhoneNumber(value);
    }
    setAlternatePhoneCountryCode(country?.dialCode);
    setAlternatePhoneNumber(value);
  };

  useEffect(() => {
    if (authToken) {
      getLeadsFilterValues();
    }
  }, [authToken]);
  const getLeadsFilterValues = async () => {
    axios.defaults.headers.common['x-access-token'] = authToken
  }

  useEffect(() => {
    const code = "+" + phoneCountryCode; // Specify the code you want to find
    const result = countryCodeList.find(item => item.startsWith(code));
    if (result) {
      setCountryCode(result);
    }
  }, [phoneCountryCode]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
    if (role === "Lead Manager" && organizationUsers) {
      let uids: { [key: string]: string } = {};
      let data: any = [];
      organizationUsers.map((item: any) => {
        data.push(
          `${item.user_first_name} ${item.user_last_name}-${item.user_email}`
        );
        uids[item.user_email] = item.uid;
      });
      setUsersList(data);
      setUidList(uids);
    }
  }, []);

  useEffect(() => {
    const unsub = contactResources(
      user.organization_id,
      (data) => setLocationsList(data),
      (data) => setBudgetsList(data),
      (data) => setProjectsList(data),
    );

    const unsubConst = fetchConstants(
      (data) => setNotIntReasonList(data),
      (data) => setLostReasonList(data),
      (data) => setPropertyStageList(data),
      (data) => setPropertyTypeList(data),
      (data) => setnextFollowUpList(data)
    );
    let data = ["Data", "Leads"];
    setleadTypeList(data);
    const unsubProperty = fetchpropertySubType(
      user.organization_id,
      (data) => setComTypes(data),
      (data) => setResTypes(data),
      (data) => setLeadSourceList(data)
    );
    setQueryType([
      { label: "Sales", value: "Sales" },
      { label: "Service", value: "Service" },
    ]);
    return () => {
      unsub();
      unsubConst();
      unsubProperty();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (propertyTypeSelected.value === "Commercial") {
      setPropertySubType(comTypes);
    } else if (
      propertyTypeSelected.value === "Residential"
    ) {
      setPropertySubType(resTypes);
    } else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);

  useEffect(() => {
    let data: any[] = [];
    country_code.forEach((item) => {
      data.push(item.dial_code + " " + item.name);
    });
    setCountryCodeList(data);
  }, []);

  useEffect(() => {
    let selected: string[] = [];
    if (user.country) {
      selected = countryCodeList.filter((item) =>
        item
          .toLowerCase()
          .includes(user.country.toLowerCase())
      );
    } else {
      selected = countryCodeList.filter((item) =>
        item.toLowerCase().includes("+91")
      );
    }
    if (selected.length !== 0) {
      setCountryCode(selected[0]);
    }
  }, [user.country, countryCodeList]);

  const handleQueryTypeSelection = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = queryType.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setQueryTypeSelected(selectedObj);
  };

  const create = async (e: any) => {
    e.preventDefault();
    if (user.organization_id) {
      if (firstNameRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "First Name Required!!",
            "error"
          )
        );
        return;
      } else if (lastNameRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "Last Name Required!!",
            "error"
          )
        );
        return;
      } else if (finalPhoneNumber === "") {
        dispatcher(
          showSnackbarAction(
            "Mobile Number Required!!",
            "error"
          )
        );
        return;
      } else if (
        emaileRef.current.value !== "" &&
        emailValidate(emaileRef.current.value) ===
        "Invalid Email"
      ) {
        dispatcher(
          showSnackbarAction("Invalid Email!!", "error")
        );
        return;
      } else if (countryCode === "") {
        dispatcher(
          showSnackbarAction(
            "Country Code Required!!",
            "error"
          )
        );
        return;
      } else if (queryTypeSelected.value === "Select") {
        dispatcher(
          showSnackbarAction(
            "Query type Required!!",
            "error"
          )
        );
      }
      setLoad(true);
      let l = ownerSelected.value.split("-");
      let email = l[1];
      const country = country_code.find(
        (el: any) =>
          el.dial_code === countryCode.split(" ")[0]
      );
      const finalData = {
        name: firstNameRef.current.value + " " + lastNameRef.current.value,
        email_id: emaileRef.current.value,
        contact_no: finalPhoneNumber,
        alternate_no: finalAlternatePhoneNumber,
        query_type: queryTypeSelected.value === "Select"
          ? ""
          : queryTypeSelected.value,
        country: country?.name,
        query: noteRef.current.value
      };
      const queryEmailforAdmin = {
        "template_name": "Query_Support_Notification",
        "replaceable_params": [
          { "%#username#%": finalData.name },
          { "%#useremail#%": finalData.email_id },
          { "%#usermobileno#%": finalData.contact_no },
          { "%#useraltno#%": finalData.alternate_no },
          { "%#usercountry#%": finalData.country },
          { "%#querytype#%": finalData.query_type },
          { "%#userquery#%": finalData.query }
        ],
        "email": admin_mail
      }
      await axios.post(
        url + '/email/sendEmail',
        queryEmailforAdmin
      );
      setLoad(false);
      dispatcher(
        showSnackbarAction(
          "Your query sent to Support Team. We will contact you soon.",
          "success"
        )
      );
      history.push("/");
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load === true && <Loading />}
      {isMobile && (
        <div className="d-flex flex-row w-100 px-4 pt-2">
          <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Help And Support</h5>
        </div>
      )}
      <div
        className="w-100 d-flex flex-column gap-2 px-4"
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: isMobile ? 'auto' : undefined,
          maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
        }}
      >
        <form
          className="card p-4 shadow rounded mt-2"
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="First Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={firstNameRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Last Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={lastNameRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Email ID"
                style={{ backgroundColor: "#fff", width: '100%' }}
                validator={emailValidate}
                ref={emaileRef}
              />
            </Grid>
            <Grid item xs={12} sm={4} style={{ marginTop: "2px" }}>
              <PhoneNumberWrapper
                title="Mobile Number"
                country={phoneCountryCode || 'in'}
                value={phoneNumber || ''}
                handlePhoneChange={handlePhoneChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4} style={{ marginTop: "2px" }}>
              <PhoneNumberWrapper
                title="Alternate No"
                country={alternatePhoneCountryCode || 'in'}
                value={alternatePhoneNumber || ''}
                handlePhoneChange={handleAlternatePhoneChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="Query Type"
                options={queryType}
                value={queryTypeSelected.value === "Select" ? "" : queryTypeSelected.value}
                onChange={handleQueryTypeSelection}
                required
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <CustomTextArea
                fullWidth
                label="Query"
                inputRef={noteRef}
                required
                variant="outlined"
                multiline
                rows={2}
                onChange={(e) => setNote(e.target.value)}
                value={note}
                InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
              />
            </Grid>
            {/* Remove submit button from inside form for mobile */}
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={create}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>Submit</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </div>
      {/* Sticky Save/Submit Button on Mobile */}
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={create}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </StyledSubmitButton>
          {/* <Button
            type="submit"
            variant="contained"
            fullWidth
            onClick={create}
            sx={{
              backgroundColor: "#272944 !important",
              color: "white !important",
              fontWeight: "600 !important",
              borderRadius: "8px !important",
              textTransform: "none !important",
              py: 1.2,
            }}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </Button> */}
        </Box>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    role: state.user.role,
    theme: state.theme.isLightMode,
    conatctHeader: state.contactHeaderList.data,
    authToken: state.user.authToken,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(HelpAndSupport);
